module.exports = __webpack_public_path__ + "fonts/NotoSansLao-Regular.4567382.woff2";